import { SET_TERMS, SET_PRIVACY_POLICY} from '../../actions/types/types';

const initState = {
  terms: {},
  privacyPolicy:{}
};

const AgreementReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_TERMS:
      return {
        ...state,
        terms: action.payload.data,
      };
    case SET_PRIVACY_POLICY:
      return { ...state, privacyPolicy: action.payload.data };
    default:
      return { ...state };
  }
};

export default AgreementReducer;
